<template>
  <div>
    <h1 class="display-4">Liste des images</h1>
    <hr />

    <router-link tag="p" to="/image/edit">
      <a class="btn btn-large btn-primary">Ajouter une image</a>
    </router-link>

    <b-table class="mt-3" :dark="theme == 'dark'" responsive hover striped :items="images" :fields="fields" :current-page="currentPage" :per-page="perPage" v-show="totalRows > 0">
      <template slot="author" slot-scope="cell">
        {{ cell.item.ionis != undefined ? cell.item.ionis.first_name : '' }} {{ cell.item.ionis != undefined ? cell.item.ionis.last_name : '' }}
      </template>
      <template slot="image" slot-scope="cell">
        <img height="200" :src="cell.item.name" />
      </template>
      <template slot="bydefault" slot-scope="cell">
        <font-awesome-icon icon="check-circle" class="text-success" v-show="cell.item.bydefault"></font-awesome-icon>
      </template>
      <template slot="actions" slot-scope="cell">
        <router-link tag="a" class="btn btn-sm btn-primary" :to="{ name: 'ImageEditExist', params: {id: cell.item.id } }">
          Editer
        </router-link>
        <b-button size="sm" variant="danger" v-b-modal.modal-delete class="mr-1" @click.prevent="deleteId(cell.item.id)" v-show="!cell.item.bydefault">
          Supprimer
        </b-button>
      </template>
    </b-table>

    <b-row v-show="totalRows > perPage">
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <p class="text-center" v-show="totalRows == 0"><em>Il y a aucune image pour le moment...</em></p>

    <b-modal id="modal-delete" title="Suppression de l'image" cancel-title="Annuler" :ok-disabled="!canDelete" ok-title="Supprimer" ok-variant="danger" @ok="deleteImage" @cancel="cancel">
      <p v-show="canDelete">Souhaitez-vous supprimer cette image ?</p>
      <b-alert variant="danger" :show="!canDelete">
        <p>Cette image a déjà {{ numberEvents }} événements qui lui sont rattachées, si vous la supprimez, ces événements n'auront plus d'image. Merci de modifier les événements avant de la supprimer.</p>
      </b-alert>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

Vue.use(VueResource)

export default {
  data () {
    return {
      canDelete: false,
      currentPage: 1,
      fields: {
        image: {
          label: 'Image',
          sortable: false
        },
        type: {
          label: 'Type',
          key: 'type.name',
          sortable: false
        },
        school: {
          label: 'Ecole',
          key: 'school.name',
          sortable: false
        },
        bydefault: {
          label: 'Par défaut',
          sortable: false
        },
        author: {
          label: 'Uploadée par',
          sortable: false
        },
        actions: {
          label: 'Actions',
          key: 'actions'
        }
      },
      idToDelete: '',
      images: [],
      numberEvents: 0,
      perPage: 20
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'role', 'schools', 'theme']),
    totalRows () {
      return this.images.length
    }
  },
  methods: {
    cancel () {
      this.idToDelete = ''
    },
    deleteId (id) {
      this.idToDelete = id
    },
    deleteImage () {
      this.$http.delete(this.domain + '/api/images/' + this.idToDelete + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          if (response.status === 200 && response.ok) {
            this.idToDelete = ''
            // this.flash('L\'image a bien été supprimée', 'success', { timeout: 3000 })
            this.$root.$bvToast.toast('L\'image a bien été supprimée', {
              title: 'Image supprimée',
              autoHideDelay: 3000,
              append: false,
              variant: 'success'
            })
            this.showImages()
          }
        })
      }, (response) => {

      })
    },
    showImages () {
      let where = ''
      if (this.role !== 'admin') {
        for (let i = 0; i < this.schools.length; i++) {
          where += '&filter[where][or][' + i + '][schoolId]=' + this.schools[i].id
        }
      }
      this.$http.get(this.domain + '/api/images?filter[include]=school&filter[include]=type&filter[include]=ionis' + where + '&access_token=' + this.access_token).then((response) => {
        response.json().then((data) => {
          this.images = data
        })
      }, (response) => {

      })
    }
  },
  mounted () {
    this.showImages()
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      // On vérifie si il y a pas déjà des événements avec des labels
      if (modalId === 'modal-delete' && this.idToDelete) {
        this.$http.get(this.domain + '/api/events?filter[where][imageId]=' + this.idToDelete + '&access_token=' + this.access_token).then((response) => {
          response.json().then((data) => {
            this.numberEvents = data.length
            if (data.length === 0) {
              this.canDelete = true
            } else {
              this.canDelete = false
            }
          })
        }, (response) => {

        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Images/List.vue